// File: src/components/host/HostTopNav.jsx

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LuArrowLeft } from 'react-icons/lu';
import { ReactComponent as TribeLogo } from '../../assets/TribeLogo.svg';

// -------------------------------
// Styles (copied from UpdateAccountPage)
// -------------------------------
const headerContainerStyle = {
  display: 'flex',
  flexDirection: 'column',
  position: 'sticky',
  top: 0,
  background: '#fff',
  zIndex: 100,
};

const headerLogoRowStyle = {
  display: 'flex',
  justifyContent: 'center',
  marginTop: 6,
};

const logoSvgStyle = {
  width: 72,
  height: 'auto',
};

const headerNavRowStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  height: 44,
  padding: '0 1rem',
};

const backButtonStyle = {
  position: 'absolute',
  left: 16,
  background: '#000',
  color: '#fff',
  borderRadius: 9999,
  width: 40,
  height: 28,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  border: 'none',
};

const pageTitleStyle = {
  fontSize: '0.95rem',
  fontWeight: 900,
  lineHeight: 1,
  textTransform: 'uppercase',
  letterSpacing: 0.2,
};

const progressContainerStyle = {
  position: 'absolute',
  right: '1rem',
  top: '50%',
  transform: 'translateY(-50%)',
};

// -------------------------------
// Progress Pill (reused)
// -------------------------------
function ProgressPill({ step, total }) {
  return (
    <div
      style={{
        background: '#f3f4f6',
        border: '1px solid #e5e7eb',
        color: '#0b0b0b',
        borderRadius: 999,
        padding: '6px 12px',
        fontSize: 12,
        fontWeight: 500,
      }}
    >
      Step <span style={{ fontWeight: 900 }}>{step}</span>/{total}
    </div>
  );
}

// -------------------------------
// MAIN NAV COMPONENT
// -------------------------------
export default function HostTopNav({
  title,
  step,
  totalSteps,
  backTo = '/host',

  // ✅ NEW: hide logo/back/steps when used inside modal
  hideChrome = false,
}) {
  const navigate = useNavigate();

  return (
    <header style={headerContainerStyle}>
      {/* Logo */}
      {!hideChrome && (
        <div style={headerLogoRowStyle}>
          <TribeLogo style={logoSvgStyle} />
        </div>
      )}

      {/* Nav row */}
      <div style={headerNavRowStyle}>
        {/* Back */}
        {!hideChrome && (
          <button onClick={() => navigate(backTo)} style={backButtonStyle} type="button">
            <LuArrowLeft size={16} color="#fff" />
          </button>
        )}

        <div style={pageTitleStyle}>{title}</div>

        {/* Steps */}
        {!hideChrome && step && totalSteps && (
          <div style={progressContainerStyle}>
            <ProgressPill step={step} total={totalSteps} />
          </div>
        )}
      </div>
    </header>
  );
}
